import { Navigate, Outlet, Route, Routes } from "react-router";

import PatientPage from "./pages/PatientPage";
import PatientsPage from "./pages/PatientsPage";
import { LoggedInOnly } from "./components/LoggedInOnly";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="protected"
        element={
          <LoggedInOnly>
            <Outlet />
          </LoggedInOnly>
        }
      >
        <Route path="all-patients" element={<PatientsPage />} />
        <Route path="patient/:id" element={<PatientPage />} />
      </Route>
      <Route
        path="*"
        element={<Navigate to={"/protected/all-patients"} replace />}
      />
    </Routes>
  );
};
